import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import useComplianceStore from '../../store'

export default async function loader({ params }) {
  logger.debug(
    '[loader] About to await AppState being ready in Edit Leave Type loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Edit Leave Type loader'
  )

  const getLeaveType = params.leaveTypeId
    ? useComplianceStore.getState().getLeaveType(params.leaveTypeId)
    : null

  const getStaffMembers = useComplianceStore.getState().getStaffMembers(false)

  const getStaffRoles = useComplianceStore.getState().getStaffRoles(false)

  const getPayClassifications = useComplianceStore
    .getState()
    .getPayClassifications()

  return defer({
    data: Promise.all([
      getLeaveType,
      getStaffMembers,
      getStaffRoles,
      getPayClassifications,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Edit Leave Type Promise.all error', error)
        return false
      }),
  })
}
